import React, { FC } from 'react'
import { Trans, t } from '@lingui/macro'
import classNames from 'classnames'

import './QuizResults.less'
import { formatDateAndTimeLong } from 'front-end/src/utils/dateHelpers'

import { QuizOption } from '../quizOption/QuizOption'
import { IQuizzesResults } from '../types'
import { TopicElementTypeEnum } from '../../../../../../../types/TopicElementTypeEnum'
import { QuizElementTypeShort } from '../../../constants/QuizElementTypes'
import { fonts } from 'front-end/src/components/chakraThemeExtension'
import { Box } from 'front-end/src/components'

export const QuizResults: FC<{ quizResults: IQuizzesResults[] }> = (props) => {
  if (!props.quizResults) {
    return <Trans>No quiz results data available</Trans>
  }

  return (
    <>
      {props.quizResults.map((quizResult, i) => {
        const isOpenQuiz = quizResult.type === TopicElementTypeEnum.QUIZ_OPEN
        const isFreeQuiz = quizResult.type === TopicElementTypeEnum.QUIZ_FREE
        const isScorm = quizResult.type === TopicElementTypeEnum.SCORM

        const { options } = quizResult

        return (
          <div className="QuizResult" key={`QuizResult-${i}`}>
            <div className="QuizResult__content">
              <div className="QuizResult__header">
                <Trans>Question {i + 1} - type</Trans>{' '}
                {QuizElementTypeShort[quizResult.type]}
              </div>
              <div
                className="page-content page-content--analytics"
                dangerouslySetInnerHTML={{
                  __html: ((quizResult as any).content ||
                    quizResult.data?.content) as string // TODO validate that we indeed have elements that only have `content` and no `data.content`
                }}
              />
              <div className="QuizResult__answer">
                {isFreeQuiz ? (
                  <span>
                    <Trans>Answer</Trans>:{' '}
                    <Box as="pre" my={0} fontFamily={fonts.body}>
                      {quizResult.freeQuizResponse || t`N/A`}
                    </Box>
                  </span>
                ) : (
                  options &&
                  options.map((option) => (
                    <QuizOption
                      key={option.id}
                      option={option}
                      isCorrect={quizResult.response_is_correct}
                      isOpenQuiz={isOpenQuiz}
                      totalResponses={+!!quizResult.created_at}
                      viewAsStudent={true}
                    />
                  ))
                )}
                {isScorm && quizResult.scormQuizResponse && (
                  <span>
                    <Trans>Answer</Trans>:{' '}
                    {quizResult.scormQuizResponse
                      .split('\n')
                      .map((response, i) => (
                        <p key={i}>{response}</p>
                      ))}
                  </span>
                )}
              </div>
            </div>

            <div className="QuizResult__assessment">
              {!isOpenQuiz && !isFreeQuiz && quizResult.created_at && (
                <div
                  className={classNames({
                    'QuizResult__assessment--correct':
                      quizResult.response_is_correct === true,
                    'QuizResult__assessment--incorrect':
                      quizResult.response_is_correct === false
                  })}
                >
                  <span className="QuizResult__assessment__label">
                    {quizResult.response_is_correct === true
                      ? t`Correct`
                      : t`Incorrect`}
                  </span>
                </div>
              )}
              {quizResult.created_at && (isOpenQuiz || isFreeQuiz || isScorm) && (
                <div className="QuizResult__assessment--correct">
                  <span className="QuizResult__assessment__label">
                    <Trans>Answered</Trans>
                  </span>
                </div>
              )}
              {!quizResult.created_at && (
                <div className="QuizResult__assessment--no-answer">
                  <span className="QuizResult__assessment__label">
                    <Trans>Not answered</Trans>
                  </span>
                </div>
              )}
              <div className="QuizResult__assessment__time">
                {quizResult.created_at ? (
                  formatDateAndTimeLong(quizResult.created_at)
                ) : (
                  <span>
                    <Trans>User hasn't responded yet</Trans>
                  </span>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}
